// Workspace-owned config. The monolith's `src/config/config.ts` reads
// `process.env.REACT_APP_*` directly (a webpack-DefinePlugin idiom) and is therefore
// not bundler-portable — Vite would need to fake `process` at runtime. So the workspace
// declares its own config natively, sourcing env values via `import.meta.env.VITE_*`.
// Values get added here when a workspace consumer actually needs them.

import {ErrorType} from "config/errors";

const fileSizeLimitInMb = 10;

export const config = {
    fileSizeLimitInMb,
    // Fallback locale when the user's locale has no translations (read by LookupTranslations).
    defaultLocale: "en-gb" as const,
    fileSizeLimit: fileSizeLimitInMb * 1000000,
    allowedAttachmentFormat: ["image/jpg", "image/jpeg", "image/png", "image/gif", "application/pdf"],
    // brandOverride is read by shared `utils/brand.ts` (test-only flag). Workspace
    // sources it from VITE_BRAND_OVERRIDE; defaults to undefined (no override).
    brandOverride: import.meta.env.VITE_BRAND_OVERRIDE as string | undefined,
    sentryDsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
    sentryEnvironment: import.meta.env.VITE_SENTRY_ENV as string | undefined,
    sentryTracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
    sentrySampleRate: import.meta.env.VITE_SENTRY_SAMPLE_RATE,
    sentryIgnoredErrors: [
        "AbortError",
        ErrorType.HTTP_REQUEST_NETWORK_ERROR,
        ErrorType.HTTP_REQUEST_ABORT_ERROR,
        ErrorType.FILE_TOO_BIG,
    ],
};

export default config;
